/** Cash Out Program — 4-level shopping matrix (separate from 15-level AFP). */

export const CASH_OUT_MATRIX_MAX_LEVEL = 4;
export const CASH_OUT_MATRIX_BASE_PAYMENT = 150;
export const CASH_OUT_MATRIX_FILLS_PER_LEVEL = 3;

/** Per ₹300 COP enrollment: ₹150 → matrix fill, ₹150 → Rewards & Retirement. */
export const CASH_OUT_MATRIX_LEG_PER_ENROLLMENT = 150;
export const CASH_OUT_ENROLLMENT_REWARDS_AMOUNT = 150;

/** Step 4 — per ₹1,200 fill (×3 per cycle). */
export const CASH_OUT_STEP4_UNIT = 1200;
export const CASH_OUT_STEP4_CASH_WALLET = 750;
export const CASH_OUT_STEP4_MAIN_AFP_POINTS = 150;
export const CASH_OUT_STEP4_COP_PROGRAM = 150;
export const CASH_OUT_STEP4_REWARDS = 150;

export function uplineCashOutEnrollmentIndexForMatrixFillSeq(fillSeq) {
  const n = Number(fillSeq);
  if (n < 1) return null;
  return Math.floor((n - 1) / CASH_OUT_MATRIX_FILLS_PER_LEVEL) + 1;
}

export function getCashOutMatrixLevelAmount(level) {
  const L = Number(level);
  if (L < 1 || L > CASH_OUT_MATRIX_MAX_LEVEL) return 0;
  return CASH_OUT_MATRIX_BASE_PAYMENT * Math.pow(2, L - 1);
}

export function getCashOutMatrixLevelTotals(level) {
  const amount = getCashOutMatrixLevelAmount(level);
  return {
    levelAmount: amount,
    threePayments: amount * CASH_OUT_MATRIX_FILLS_PER_LEVEL,
    cashOutPerLevel: amount,
    upgradePool: amount * 2,
  };
}

export function buildCashOutMatrixReferenceRows() {
  const rows = [];
  let cumulativeCashOut = 0;
  for (let level = 1; level <= CASH_OUT_MATRIX_MAX_LEVEL; level += 1) {
    const autoFill = getCashOutMatrixLevelAmount(level);
    const totals = getCashOutMatrixLevelTotals(level);
    const isLast = level === CASH_OUT_MATRIX_MAX_LEVEL;
    const autoUpgrade = isLast ? 0 : totals.upgradePool;
    const cashOutMoney = isLast
      ? totals.threePayments
      : totals.cashOutPerLevel;
    cumulativeCashOut += cashOutMoney;
    rows.push({
      level,
      autoFill,
      fillCount: CASH_OUT_MATRIX_FILLS_PER_LEVEL,
      total: totals.threePayments,
      autoUpgrade,
      autoUpgradeLabel: isLast ? "NO Upgrade" : autoUpgrade,
      cashOutMoney,
      cumulativeCashOut,
    });
  }
  return rows;
}

export function validateStep4Split() {
  const sum =
    CASH_OUT_STEP4_CASH_WALLET +
    CASH_OUT_STEP4_MAIN_AFP_POINTS +
    CASH_OUT_STEP4_COP_PROGRAM +
    CASH_OUT_STEP4_REWARDS;
  return sum === CASH_OUT_STEP4_UNIT;
}
